// extracted by mini-css-extract-plugin
module.exports = {"Centered":"src_Centered__1vUrV","CenteredScreen":"src_CenteredScreen__26qE1 src_Centered__1vUrV","bottomSpace":"src_bottomSpace__3Uvn_","error":"src_error__1nrfv"};